import React from "react";
import { MdOutlineLabelImportant } from "react-icons/md";
import Image from "../../designLayouts/Image";
import Badge from "./Badge";
import { useNavigate } from "react-router-dom";

const Product = (props) => {
  // Product slug generator for SEO-friendly URLs
  const createSlug = (text) => {
    return String(text)
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")   // convert spaces/special chars to hyphen
      .replace(/(^-|-$)+/g, "");     // remove hyphens from start/end
  };

  const productSlug = createSlug(props.productName);
  const navigate = useNavigate();

  const handleProductDetails = () => {
    navigate(`/product/${productSlug}`, {
      state: { item: props },
    });
  };

  return (
    <article 
      className="w-full relative group"
      itemScope
      itemType="https://schema.org/Product"
    >
      <div className="max-w-80 max-h-80 relative overflow-y-hidden">
        
        {/* Product Image (SEO-friendly alt text) */}
        <div
          className="cursor-pointer"
          onClick={handleProductDetails}
          role="button"
          aria-label={`View details for ${props.productName}`}
        >
          <Image
            className="w-full h-full"
            imgSrc={props.img}
            alt={`${props.productName} - RK Global Trader Import Export`}
          />
        </div>

        {/* New Badge */}
        {props.badge && (
          <div className="absolute top-6 left-8">
            <Badge text="New Arrival" />
          </div>
        )}

        {/* Hover Options */}
        <div className="w-full h-3 absolute bg-white -bottom-[130px] group-hover:bottom-0 duration-700">
          <ul className="w-full h-full flex flex-col items-end justify-center gap-2 font-titleFont px-2 border-l border-r">

            {/* View Details Button — SEO Keyword Added */}
            <li
              onClick={handleProductDetails}
              className="text-[#767676] hover:text-primeColor text-sm border-b border-b-gray-200 hover:border-b-primeColor flex items-center justify-end gap-2 cursor-pointer pb-1 duration-300 w-full"
              itemProp="url"
            >
              View Product Details – {props.productName}
              <span className="text-lg"><MdOutlineLabelImportant /></span>
            </li>
          </ul>
        </div>
      </div>

      {/* Product Info Box */}
      <div className="max-w-80 py-4 flex flex-col gap-1 border border-t-0 px-4">

        <div className="flex items-center justify-between font-titleFont">
          <h2
            className="text-lg text-primeColor font-bold"
            itemProp="name"
          >
            {props.productName}
          </h2>
        </div>

        <div>
          {/* Added keyword-friendly label */}
          <p 
            className="text-[#767676] text-[14px]"
            itemProp="color"
          >
            Variant: {props.color}
          </p>
        </div>
      </div>
    </article>
  );
};

export default Product;
